export default __webpack_public_path__ + "static/logo-e9389119edf19e856a0c3d0cf5d2509f.png";